import { Constants } from '../app.constants';

export class PromiseResponse {

    public status: number = Constants.STATUS.OK;
    public message: string = "";
    public data: any;

} 